import { combineReducers } from "redux";
import { informationPageReducer } from "./information/reducer";
import { projectListReducer } from "./project-list/project-list-store";
import { addEditProjectDialogReducer } from "./project-list/components/add-edit-project-dialog/add-edit-project-dialog-store";
import { employeeInformationReducer } from "./contact/contact-info-store";
import { faqReducer } from "./faq/faq-store";
import { profileReducer } from "./profile/reducer";
import { priceListReducer } from "./price-list/price-list-store";
import { productDetailsReducer } from "./product-details/product-details-store";
import { combinedConfiguratorReducer } from "./configurator/reducer";
import { configureProductReducer } from "./configure-product/configure-product-store";

export const pageReducer = combineReducers({
  informationPageReducer,
  projectListReducer,
  addEditProjectDialogReducer,
  employeeInformationReducer,
  faqReducer,
  profileReducer,
  priceListReducer,
  productDetailsReducer,
  combinedConfiguratorReducer,
  configureProductReducer
});
